module.exports = "<app-img-header imgUrl=\"/assets/images/img-headers/gallery.jpg\"></app-img-header>\r\n<div class=\"gallery-container\">\r\n  <div class=\"container\">\r\n    <h1 translate>\r\n      GALLERY.TITLE\r\n    </h1>\r\n\r\n    <p translate [innerHTML]=\"'GALLERY.TEXT' | translate\">\r\n    </p>\r\n\r\n    <gallery [galleryName]=\"galleryName\">\r\n    </gallery>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/gallery/gallery.component.html
// module id = 782
// module chunks = 1